import { GsFormSchema } from '../../../components';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the iframe component form.
 * Defines the fields to display for the form
 */
export const IFRAME_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'content',
      label: 'components.iframe.schema.url',
      type: 'text',
      inputType: 'url',
      default: 'https://example.com'
    },
    {
      formControlName: 'height',
      label: 'components.iframe.schema.height',
      type: 'number',
      min: 50,
      max: 10000,
      default: 300
    },
    {
      formControlName: 'title',
      label: 'components.iframe.schema.title',
      type: 'text',
      default: ''
    },
    {
      formControlName: 'description',
      label: 'components.iframe.schema.description',
      type: 'text',
      default: ''
    }
  ]
};
